import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Spacer } from 'foundations-components/components/Spacer';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import UIBox from 'UIComponents/layout/UIBox';
import UIButton from 'UIComponents/button/UIButton';
import UIFlex from 'UIComponents/layout/UIFlex';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SecurityPhoneNumberSuccess = props => {
  const {
    redirectUrl
  } = props;
  return /*#__PURE__*/_jsx(UIFlex, {
    justify: "center",
    children: /*#__PURE__*/_jsx(UIBox, {
      basis: "500px",
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        flexDirection: "column",
        children: [/*#__PURE__*/_jsx(Spacer, {
          space: "700"
        }), /*#__PURE__*/_jsx("h2", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "userPreferences.securityPhoneNumber.successTitle"
          })
        }), /*#__PURE__*/_jsx(Spacer, {
          space: "700"
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "userPreferences.securityPhoneNumber.success"
          })
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "userPreferences.securityPhoneNumber.registerSms.successDetails"
          })
        }), /*#__PURE__*/_jsx(Illustration, {
          marginBlock: "600",
          name: "success",
          width: "200px"
        }), redirectUrl && /*#__PURE__*/_jsx(_Fragment, {
          children: /*#__PURE__*/_jsx(UIFlex, {
            direction: "column",
            align: "center",
            children: /*#__PURE__*/_jsx(UIButton, {
              use: "transparent",
              className: "m-top-6",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "userPreferences.securityPhoneNumber.redirectTitle"
              })
            })
          })
        })]
      })
    })
  });
};
SecurityPhoneNumberSuccess.propTypes = {
  redirectUrl: PropTypes.string
};
export default SecurityPhoneNumberSuccess;